import { render, staticRenderFns } from "./proprio.vue?vue&type=template&id=9b0275d6"
import script from "./proprio.vue?vue&type=script&lang=js"
export * from "./proprio.vue?vue&type=script&lang=js"
import style0 from "./proprio.vue?vue&type=style&index=0&id=9b0275d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports